
import searchDialogComponent from './dialog.vue'
const searchDialog = {
  install: function(Vue) {
    Vue.component('searchDialog', searchDialogComponent)
  }
}
export default searchDialog



// WEBPACK FOOTER //
// ./src/components/searchDialog/index.js